import { render, staticRenderFns } from "./ModalViewProfile.vue?vue&type=template&id=6c411b6c&scoped=true&"
import script from "./ModalViewProfile.vue?vue&type=script&lang=js&"
export * from "./ModalViewProfile.vue?vue&type=script&lang=js&"
import style0 from "./ModalViewProfile.vue?vue&type=style&index=0&id=6c411b6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c411b6c",
  null
  
)

export default component.exports